import React from "react";

import {
  HorizontalProductCard as ProductCard,
  ProductCardDataType
} from "../components/index";

type Props = {
  productCardData: ProductCardDataType;
  onButtonClick?: () => void;
  onShadeSelectorClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onWishlistToggle?: (productCardData: ProductCardDataType) => void;
  onCardClick?: (
    event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>
  ) => void;
  buttonVariant?: "primary" | "secondary";
  disableLink?: boolean;
};

export const StandardHorizontalProductCard = React.forwardRef<
  HTMLDivElement | HTMLAnchorElement,
  Props
>(
  (
    {
      productCardData,
      onButtonClick,
      onShadeSelectorClick,
      onWishlistToggle,
      onCardClick,
      buttonVariant,
      disableLink
    },
    ref
  ) => {
    return (
      <ProductCard
        product={productCardData}
        onClick={onCardClick}
        disableLink={disableLink}
        ref={ref}
      >
        <ProductCard.Header>
          <ProductCard.Image product={productCardData} />
          {onWishlistToggle && (
            <ProductCard.Wishlist
              product={productCardData}
              onToggle={onWishlistToggle}
            />
          )}
        </ProductCard.Header>
        <ProductCard.Body>
          <ProductCard.InlineStack>
            <ProductCard.Rating product={productCardData} />
            <ProductCard.Pricing product={productCardData} />
          </ProductCard.InlineStack>
          <ProductCard.BrandName
            product={productCardData}
            textOverflow="ellipsis"
          />
          <ProductCard.ProductName
            product={productCardData}
            textOverflow="ellipsis"
          />
          {(productCardData.swatchImages?.length ?? 0) > 0 && (
            <ProductCard.ColorSwatch
              product={productCardData}
              onClick={onShadeSelectorClick}
            />
          )}
          <ProductCard.Footer>
            {onButtonClick && (
              <ProductCard.Button
                product={productCardData}
                onClick={onButtonClick}
                variant={buttonVariant}
              />
            )}
          </ProductCard.Footer>
        </ProductCard.Body>
      </ProductCard>
    );
  }
);
